import { COLORS } from 'consts/colors'
import { DURATIONS, EASING } from 'styles/consts'
import styled from 'styled-components'
import { textUnderlineAnimationStyles } from 'styles/mixins'

export const ProjectIdsWrapper = styled.div`
  display: flex;
  gap: 8px;
  width: 100%;
  flex-wrap: wrap;
  justify-content: center;
`

export const ProjectId = styled.div`
  display: inline-block;
  position: relative;
  font-size: 14px;
  font-weight: 500;
  color: ${COLORS.primaryDark};
  &::after {
    ${textUnderlineAnimationStyles()}
  }
`

export const ProjectIdBox = styled.a`
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid ${COLORS.borderColor};
  cursor: pointer;

  &:hover {
    ${ProjectId} {
      transition: color ${DURATIONS.fast} ${EASING.out};
      color: ${COLORS.primaryDark};
      &::after {
        ${textUnderlineAnimationStyles()}
        transform: scaleX(1);
      }
    }
  }
`
